import cFile from './cFile.vue';
export default {
  install(Vue) {
    Vue.component(cFile.name, cFile);
  },
};
